import { useCallback } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { LocationState } from 'src/sensors/LocationState.ts';
import { initLocationState, isLocationState, LocationStateContextType } from 'src/sensors/locationStateContext.ts';

export const useLocationState = (): [LocationState, (state: LocationState) => void] => {
    const { state } : { state: LocationStateContextType['locationState'] } = useLocation();
    const locationState = isLocationState(state) ? state : initLocationState;
    const [searchParams, setSearchParams] = useSearchParams();
    const setState = useCallback((newState: LocationState) => {
        setSearchParams(searchParams, {
            replace: true,
            state: newState,
        });
    }, [searchParams, setSearchParams]);
    return [locationState, setState];
};
